import * as React from "react";
import { renderSportIcon } from "./renderSportIcon";
import { renderGameState } from "./renderGameState";
export var renderGameStateWrapper = function (event, componentPrefix, isDesktop, dict, hideGameState) {
    return isDesktop
        ? renderGameStateDesktop(event, hideGameState, componentPrefix, dict)
        : renderGameStateMobile(event, hideGameState, componentPrefix, dict);
};
var renderGameStateDesktop = function (event, hideGameState, componentPrefix, dict) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__clock", "data-uat": "div-ev-list-" + componentPrefix + "-clock" },
        renderSportIcon(event.sportId, componentPrefix),
        !hideGameState && renderGameState(event.isLive, event.id, event.gamePart, event.gameTime, componentPrefix, dict));
};
var renderGameStateMobile = function (event, hideGameState, componentPrefix, dict) {
    return !hideGameState &&
        !event.isInKickOffState &&
        renderGameState(event.isLive, event.sportId, event.gamePart, event.gameTime, componentPrefix, dict);
};
//# sourceMappingURL=renderGameStateWrapper.js.map